import { LedgerTransactionsAction, Trace, TraceActionClient } from 'lib/apiClient'

export function mapTransactionsData(data?: { traces: Trace[] }) {
  if (!data) {
    return undefined
  }

  let ledgerTransactions: LedgerTransactionsAction | undefined

  for (const trace of data.traces) {
    if (trace.client === TraceActionClient.LedgerTransactionsClient) {
      ledgerTransactions = trace
      break
    }
  }

  if (!ledgerTransactions || !ledgerTransactions.clientOutput.transactions?.length) {
    return undefined
  }

  return {
    clientId: ledgerTransactions.clientInput.clientId,
    transactions: ledgerTransactions.clientOutput.transactions.map(t => t.data),
  }
}
